var path = '/ssd/jenkins/workspace/Unmanaged/Release_arcade-ui/app/views/ui/sunday-sky-video.html';
var html = "<div class=\"sunday-sky-video\">\n  <iframe src=\"about:blank\"></iframe>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;